import type { WorkflowOptions } from '../../types';
import { generateAssetStatusWorkflow } from '../generateAssetStatusWorkflows';
import { addTagWorkflow } from './addTagWorkflow';
import { editTagWorkflow } from './editTagWorkflow';

export const workflows: WorkflowOptions[] = [
  addTagWorkflow,
  editTagWorkflow,
  ...Object.values(generateAssetStatusWorkflow('tags')),
];

export default workflows;
